export default __webpack_public_path__ + "static/media/RetailersIcon.d8510bc6.svg";